import React, { useState, useEffect } from "react";
import { Box, Button, TextInput, Text, Heading, Select } from "grommet";
import axios from "axios";
import API_URL from "../../../config/config";

export const AddLearningPath = () => {
  const [learningPaths, setLearningPaths] = useState([
    {
      title: "",
      product_id: "",
      sub_product_id: "",
      courses: [{ title: "", courseID: "", duration: "", id: "", oem: "" }],
    },
  ]);
  const [products, setProducts] = useState([]); // To store the product skills fetched from backend
  const [loading, setLoading] = useState(true); // Loading state for products
  const [subProducts, setSubProducts] = useState([]); // To store the subproducts fetched from backend
  const [filteredSubProducts, setFilteredSubProducts] = useState([]); // To store filtered sub-products based on product selection

  // Fetch products from the backend
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${API_URL}/user/getRolesAndSkills`);
        
        setProducts(response.data.product_skills); // Assuming 'product_skills' is the key in the response
        setSubProducts(response.data.sub_product_skills);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching product skills:", error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // Function to handle learning path title change
  const handleLearningPathChange = (index, value) => {
    const updatedPaths = [...learningPaths];
    updatedPaths[index].title = value;
    setLearningPaths(updatedPaths);
  };

  // Function to handle product selection change
  const handleProductChange = (index, value) => {
    value = value.value;
    const updatedPaths = [...learningPaths];
    updatedPaths[index].product_id = value;
    
    // Filter sub-products based on the selected product ID
    
    const selectedProductSubProducts = subProducts.filter(
      (subProduct) => subProduct.product_id === value,
    );
    

    // Update the filtered sub-products for this learning path
    setFilteredSubProducts(selectedProductSubProducts);

    setLearningPaths(updatedPaths);
  };

  // Function to handle sub-product selection change
  const handleSubProductChange = (index, value) => {
    value = value.value;
    
    const updatedPaths = [...learningPaths];
    updatedPaths[index].sub_product_id = value;
    setLearningPaths(updatedPaths);
  };

  // Function to handle course details change
  const handleCourseChange = (pathIndex, courseIndex, field, value) => {
    const updatedPaths = [...learningPaths];
    updatedPaths[pathIndex].courses[courseIndex][field] = value;
    setLearningPaths(updatedPaths);
  };

  // Function to add a new course under a learning path
  const addCourse = (pathIndex) => {
    const updatedPaths = [...learningPaths];
    updatedPaths[pathIndex].courses.push({
      title: "",
      courseID: "",
      duration: "",
      id: "",
      oem: "",
    });
    setLearningPaths(updatedPaths);
  };

  // Function to add a new learning path
  const addLearningPath = () => {
    setLearningPaths([
      ...learningPaths,
      {
        title: "",
        product_id: "",
        courses: [{ title: "", courseID: "", duration: "", id: "", oem: "" }],
      },
    ]);
  };

  // Function to submit the form
  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/learningpaths/bulk_insert`,
        {
          learningPaths,
        },
      );

      alert("Learning Paths and Courses added successfully!");
    } catch (error) {
      console.error("Error adding learning paths and courses:", error);
      alert("Failed to add learning paths and courses.");
    }
  };

  return (
    <Box pad="medium">
      <Heading level="2">Add Learning Paths and Courses</Heading>
      {learningPaths.map((path, pathIndex) => (
        <Box
          key={pathIndex}
          pad="small"
          border={{ color: "brand", size: "small" }}
        >
          <Select
            margin={{ bottom: "small" }}
            placeholder="Select Product Skill"
            options={products.map((product) => ({
              label: product.name,
              value: product.id,
            }))}
            value={path.product_id}
            onChange={({ value }) => handleProductChange(pathIndex, value)}
            disabled={loading}
          />
          <Select
            margin={{ bottom: "small" }}
            placeholder="Select Sub-product"
            options={filteredSubProducts.map((subProduct) => ({
              label: subProduct.skill_name,
              value: subProduct.id,
            }))}
            value={path.sub_product_id}
            onChange={({ value }) => handleSubProductChange(pathIndex, value)}
            disabled={loading}
          />
          <TextInput
            placeholder="Learning Path Title"
            value={path.title}
            onChange={(e) =>
              handleLearningPathChange(pathIndex, e.target.value)
            }
          />
          <Box pad={{ vertical: "medium" }}>
            <Text size="large">Courses</Text>
            {path.courses.map((course, courseIndex) => (
              <Box
                key={courseIndex}
                pad="medium"
                border={{ color: "light-4", size: "small" }}
              >
                <TextInput
                  placeholder="Course Title"
                  value={course.title}
                  onChange={(e) =>
                    handleCourseChange(
                      pathIndex,
                      courseIndex,
                      "title",
                      e.target.value,
                    )
                  }
                />
                <TextInput
                  placeholder="Course ID"
                  value={course.courseID}
                  onChange={(e) =>
                    handleCourseChange(
                      pathIndex,
                      courseIndex,
                      "courseID",
                      e.target.value,
                    )
                  }
                />
                <TextInput
                  placeholder="Course Duration"
                  value={course.duration}
                  onChange={(e) =>
                    handleCourseChange(
                      pathIndex,
                      courseIndex,
                      "duration",
                      e.target.value,
                    )
                  }
                />
                <TextInput
                  placeholder="OEM"
                  value={course.oem}
                  onChange={(e) =>
                    handleCourseChange(
                      pathIndex,
                      courseIndex,
                      "oem",
                      e.target.value,
                    )
                  }
                />
                <TextInput
                  placeholder="Course Order (ID)"
                  value={course.id}
                  onChange={(e) =>
                    handleCourseChange(
                      pathIndex,
                      courseIndex,
                      "id",
                      e.target.value,
                    )
                  }
                />
              </Box>
            ))}
            <Button
              label="Add Another Course"
              onClick={() => addCourse(pathIndex)}
            />
          </Box>
        </Box>
      ))}
      <Button label="Add Another Learning Path" onClick={addLearningPath} />
      <Button label="Submit" primary onClick={handleSubmit} />
    </Box>
  );
};
